import { useSelector } from 'react-redux';
import CommanModal from '../components/CommanModal';
import { Dispatch, SetStateAction } from 'react';

interface FAQsModalProps {
  isFAQsModalOpen: boolean;
  setIsFAQsModalOpen: Dispatch<SetStateAction<boolean>>;
  onClose?: () => void;
  onLogoutClicked?: () => void;
}

function FAQsModal({
  isFAQsModalOpen,
  setIsFAQsModalOpen,
  onClose,
  onLogoutClicked,
}: FAQsModalProps) {
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );

  const { entries } = contentfulData;
  const { rb_more } = entries;
  const handleConfirmClose = () => {
    setIsFAQsModalOpen(false);
    if (onLogoutClicked) {
      onLogoutClicked();
    }
    window.open(rb_more?.moreFaqsUrl, '_blank');
  };

  const handleCancelClose = () => {
    setIsFAQsModalOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <CommanModal
      isOpen={isFAQsModalOpen}
      onClose={handleConfirmClose}
      onExtraButtonClick={handleCancelClose}
      cardStatus={true}
      jsxContent={
        <div className="text-center">
          <div
            className="mb-4 text-[#1F1F1F] text-[22px] font-medium"
            aria-label={rb_more?.faqsPopupWebTitle}
          >
            {rb_more?.faqsPopupWebTitle}
          </div>
          <p
            className="mb-[40px]"
            aria-label={rb_more?.faqsPopupWebDescription}
          >
            {rb_more?.faqsPopupWebDescription}
          </p>
        </div>
      }
      buttonText={rb_more?.moreFaqsPopupYesBtnTitle}
      extraButtonText={rb_more?.faqsPopupWebStayBtn}
      closeIcon={false}
    />
  );
}

export default FAQsModal;
